import { num, type FinanceSettings } from '../financeApi';

export type ReceiptDonor = {
  memberId: number;
  name: string;
  address: string;
  total: number;
  byMonth: number[];
};

// 기부금 영수증 인쇄 양식(소득세법 시행규칙 별지 제45호의2 서식의 주요 항목). 한 장에 한 명, 인쇄 시 쪽 나눔.
export default function ReceiptDocument({ year, donor, rrn, serialNo, church, issuedDate }: {
  year: number;
  donor: ReceiptDonor;
  rrn: string;
  serialNo: string;
  church: FinanceSettings;
  issuedDate: string;
}) {
  const months = donor.byMonth.map((amount, i) => ({ month: i + 1, amount })).filter((m) => m.amount > 0);
  const [y, m, d] = issuedDate.split('-');

  return (
    <div className="fin-doc fin-receipt">
      <div className="fin-receipt-serial">일련번호 {serialNo || '(미발급)'}</div>
      <h1>기 부 금 영 수 증</h1>

      <h2>① 기부자</h2>
      <table className="fin-doc-table">
        <tbody>
          <tr><th>성명</th><td>{donor.name}</td><th>주민등록번호</th><td>{rrn}</td></tr>
          <tr><th>주소</th><td colSpan={3}>{donor.address}</td></tr>
        </tbody>
      </table>

      <h2>② 기부금 단체</h2>
      <table className="fin-doc-table">
        <tbody>
          <tr><th>단체명</th><td>{church.churchName}</td><th>사업자등록번호<br />(고유번호)</th><td>{church.registrationNo}</td></tr>
          <tr><th>소재지</th><td colSpan={3}>{church.address}</td></tr>
          <tr><th>대표자</th><td colSpan={3}>{church.representative}</td></tr>
        </tbody>
      </table>

      <h2>③ 기부 내용</h2>
      <table className="fin-doc-table">
        <thead>
          <tr><th>유형</th><th>코드</th><th>구분</th><th>연월</th><th>내용</th><th className="fin-num">금액</th></tr>
        </thead>
        <tbody>
          {months.map((row) => (
            <tr key={row.month}>
              <td>종교단체</td><td>41</td><td>금전</td>
              <td>{year}.{String(row.month).padStart(2, '0')}</td>
              <td>헌금</td>
              <td className="fin-num">{num(row.amount)}</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr><th colSpan={5}>합계</th><td className="fin-num"><b>{num(donor.total)}</b></td></tr>
        </tfoot>
      </table>

      <p className="fin-receipt-text">
        「소득세법」 제34조, 「조세특례제한법」 제76조·제88조의4 및 「법인세법」 제24조에 따른 기부금을 위와 같이 기부하였음을 증명하여 주시기 바랍니다.
      </p>
      <p className="fin-receipt-sign">{y}년 {Number(m)}월 {Number(d)}일 &nbsp; 신청인 {donor.name} (서명 또는 인)</p>
      <p className="fin-receipt-text">위와 같이 기부금을 기부받았음을 증명합니다.</p>
      <p className="fin-receipt-sign">
        {y}년 {Number(m)}월 {Number(d)}일 &nbsp; 기부금 수령인 {church.churchName} {church.representative && `대표 ${church.representative}`} (서명 또는 인)
      </p>
    </div>
  );
}
